const probe = '__local_storage_probe__'

export default class Storage {
  constructor(namespace) {
    this.namespace = namespace
    try {
      localStorage.setItem(probe, probe)
      localStorage.removeItem(probe)
      this.isSupported = true
    } catch (error) {
      this.isSupported = false
    }
  }

  get(key, defaultValue = null) {
    let storageValue
    if (this.isSupported) {
      storageValue = window.localStorage.getItem(`${this.namespace}_${key}`)
    }
    return storageValue || defaultValue
  }

  remove(key) {
    if (this.isSupported) {
      return window.localStorage.removeItem(`${this.namespace}_${key}`)
    }

    return undefined
  }

  set(key, value) {
    if (this.isSupported) {
      return window.localStorage.setItem(`${this.namespace}_${key}`, value)
    }

    return undefined
  }
}
